module.exports = __webpack_public_path__ + "img/title.0ef3db3.png";